import { useMemo } from 'react';
import arrowLeft from '~/assets/icons/arrow_left.svg';
import arrowRight from '~/assets/icons/arrow_right.svg';
import plus from '~/assets/icons/plus_2.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { VehicleNumberPlateType } from '~/shared';
import { isCustomType } from '../../utils';
import { PlateTypeOption } from '../ChangeTab/ChangeTab.model';
import { PreviewClassic } from '../PreviewClassic';
import { PreviewClassicSquare } from '../PreviewClassicSquare';
import { PreviewCustom } from '../PreviewCustom';
import {
	StyledArrowButton,
	StyledBottomContainer,
	StyledBottomItem,
	StyledBottomItemTextContainer,
	StyledCenterContainer,
	StyledContainer,
	StyledModerationLabelContainer,
	StyledPlateTypeText,
	StyledPlusContainer,
	StyledRegionText,
	StyledShadow,
	StyledTopContainer,
} from './PlatePreview.styled';

const PlatePreview = ({
	plateType,
	regionLabel,
	handlePrevType,
	handleNextType,
	number,
	region,
	repeatedLetters,
	repeatedNumbers,
}: {
	plateType: PlateTypeOption;
	regionLabel: string;
	handlePrevType: () => void;
	handleNextType: () => void;
	number: string;
	region: string;
	repeatedLetters?: boolean;
	repeatedNumbers?: boolean;
}) => {
	const isModerationLabelVisible = useMemo(
		() => number.length > 0 && isCustomType(plateType.type),
		[number, plateType.type],
	);

	return (
		<StyledContainer>
			<StyledShadow />
			<StyledTopContainer>
				<StyledPlateTypeText style={{ fontWeight: 500 }}>
					{plateType.label}
				</StyledPlateTypeText>
				<StyledRegionText style={{ opacity: 0.5 }}>
					{regionLabel}
				</StyledRegionText>
			</StyledTopContainer>
			<StyledCenterContainer>
				<StyledArrowButton
					onClick={() => {
						handlePrevType();
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					<img src={arrowLeft} />
				</StyledArrowButton>
				{(plateType.type === VehicleNumberPlateType.Classic ||
					plateType.type === VehicleNumberPlateType.ClassicNoFlag) && (
					<PreviewClassic
						type={plateType.type}
						number={number}
						region={region}
					/>
				)}
				{plateType.type === VehicleNumberPlateType.ClassicSquareNoFlag && (
					<PreviewClassicSquare number={number} region={region} />
				)}
				{(plateType.type === VehicleNumberPlateType.Custom ||
					plateType.type === VehicleNumberPlateType.CustomBlack) && (
					<PreviewCustom type={plateType.type} number={number} />
				)}
				<StyledArrowButton
					onClick={() => {
						handleNextType();
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					<img src={arrowRight} />
				</StyledArrowButton>
			</StyledCenterContainer>
			<div>
				<StyledBottomContainer
					$active={repeatedLetters || repeatedNumbers}
					$count={repeatedLetters && repeatedNumbers ? 2 : 1}
				>
					{repeatedLetters && (
						<StyledBottomItem>
							<StyledPlusContainer>
								<img src={plus} />
							</StyledPlusContainer>
							<StyledBottomItemTextContainer>
								<Text>Одинаковые буквы</Text>
							</StyledBottomItemTextContainer>
						</StyledBottomItem>
					)}
					{repeatedNumbers && (
						<StyledBottomItem>
							<StyledPlusContainer>
								<img src={plus} />
							</StyledPlusContainer>
							<StyledBottomItemTextContainer>
								<Text>Одинаковые цифры</Text>
							</StyledBottomItemTextContainer>
						</StyledBottomItem>
					)}
				</StyledBottomContainer>
				<StyledModerationLabelContainer $active={isModerationLabelVisible}>
					<Text>*Данный номер требует рассмотрения модерации</Text>
				</StyledModerationLabelContainer>
			</div>
		</StyledContainer>
	);
};

export { PlatePreview };
